import { createNode } from '@glueapp/graph-types';

export const Sine = createNode({
    id: 'Sine',
    name: 'Sine',
    description: 'Gives the sine of the value',
    aiDescription:
        'Computes the sine of a number (in radians). Connect a value to the "Value" input port; the "Result" output port provides the sine.',
    category: 'Math',
    color: '#5daa5b',
    integration: undefined,
    inPorts: {
        Value: {
            kind: 'number',
        },
    },
    outPorts: {
        Result: {
            kind: 'number',
        },
    },
    execute: function (input) {
        return { output: { Result: Math.sin(input.inPorts.Value) } };
    },
});
